import React, {useEffect, useState, useRef} from 'react';
import axios from "axios";
import * as Sentry from "@sentry/react";
import {
    DeleteIcon
} from '@shopify/polaris-icons';
import {Button, Icon} from "@shopify/polaris";

const CartItems = ({ loading, rootUrl, crewcart, currencyFormatter,crewCartToken, userToken, settings, member, shoppingComplete }) => {
    if (!crewcart) {
        return <></>;
    }

    useEffect(()=>{
        console.log("loading");
    }, [loading]);

    const [qtyLoading, setQtyLoading] = useState(false);
    const [items, setItems] = useState(crewcart.items);
    const [updateTimer, setUpdateTimer] = useState(null);
    const initialQuantityRef = useRef(null);

    useEffect(() => {
        setItems(crewcart.items);
    }, [crewcart.items]);

    const removeItem = async(itemId, platformVariantId) => {
        setQtyLoading(true);
        try {
            const res = await axios.post(`${rootUrl}/api/crewcart/remove-item`, {
                item_id: itemId,
                user_token: userToken,
                crew_cart_token: crewCartToken
            });

            if (res.status === 200) {
                console.log('Quantity updated successfully');
                console.log({
                    type: 'REMOVE_CART_ITEM',
                    platform_variant_id: platformVariantId,
                });
                console.log('https://' + crewcart.shop.domain);
                window.parent.postMessage(
                    {
                        type: 'REMOVE_CART_ITEM',
                        platform_variant_id: platformVariantId,
                    },
                    'https://' + crewcart.shop.origin_domain
                );
                setTimeout(function() {
                    setQtyLoading(false);
                }, 2000);
            }
        } catch (err) {
            setQtyLoading(false);
            console.error('Error updating quantity:', err.message);
        }
    }

    const alterQty = async (itemId, platformVariantId, currentQty, newQty) => {
        // Store the initial quantity when starting a new sequence of changes
        if (initialQuantityRef.current === null) {
            initialQuantityRef.current = currentQty;
        }

        Sentry.addBreadcrumb({
            category: 'cart.quantity',
            message: `Quantity update attempt: ${initialQuantityRef.current} -> ${newQty}`,
            level: 'info',
            data: {
                itemId,
                platformVariantId,
                originalQty: initialQuantityRef.current,
                newQty: newQty
            }
        });

        // Immediately update the UI
        setItems(prevItems => prevItems.map((item) => ({
            ...item,
            quantity: (item.platform_variant_id === platformVariantId && item?.member?.id === member?.id) ? newQty : item.quantity
        })));

        // Clear any existing timer
        if (updateTimer) {
            clearTimeout(updateTimer);
        }

        // Set new timer for backend update
        const timer = setTimeout(async () => {
            setQtyLoading(true);
            try {
                const res = await axios.post(`${rootUrl}/api/crewcart/update-quantity`, {
                    item_id: itemId,
                    quantity: newQty,
                    user_token: userToken,
                    crew_cart_token: crewCartToken
                });

                window.parent.postMessage(
                    {
                        type: 'UPDATE_CART',
                        item: {
                            'id': platformVariantId,
                            'quantity': newQty
                        }
                    },
                    'https://' + crewcart.shop.origin_domain
                );

                if (res.status === 200) {
                    setQtyLoading(false);
                    console.log('Quantity updated successfully');
                    // Reset the initial quantity reference after successful update
                    initialQuantityRef.current = null;
                }
            } catch (err) {
                // Revert the optimistic update on error
                setItems(prevItems => prevItems.map((item) => ({
                    ...item,
                    quantity: item.platform_variant_id === platformVariantId ? initialQuantityRef.current : item.quantity
                })));
                setQtyLoading(false);
                initialQuantityRef.current = null; // Reset on error too
                console.error('Error updating quantity:', err.message);
            }
        }, 500);

        setUpdateTimer(timer);
    };

    const deleteItem = async (itemId) => {
        try {
            const res = await axios.post(`${rootUrl}/api/crewcart/delete-item`, {
                itemId,
                token: crewCartToken,
            });
            if (res.status === 200) {
                console.log('Item deleted successfully');
            }
        } catch (err) {
            console.error('Error deleting item:', err.message);
        }
    };


    return (
        <div>
            <div className="crew-cart-items">
                {items?.length > 0 ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="cart-item"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '2px',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'left',
                                    width: '100%',
                                    lineHeight: '16px',
                                    overflow: 'hidden',
                                    gap: '10px'
                                }}
                            >
                                <img
                                    src={item.image_url?.replace(/\\\//g, '/')}
                                    alt="Product Thumbnail"
                                    style={{
                                        objectFit: 'cover',
                                        mixBlendMode: 'multiply',
                                        width: '50px',
                                        height: '50px',
                                    }}
                                />
                                <div style={{flex: 1}}>
                                    <p style={{margin: 0}}>
                                        <a
                                            style={{
                                                color: '#000',
                                                textDecoration: 'none',
                                                fontWeight: 'bold',
                                                fontSize: '1.1em'
                                            }}
                                            href={`https://${crewcart.shop.origin_domain}/products/${item.handle}`}
                                            target="_top"
                                            title={item.title}
                                        >
                                            {item.title.substring(0, 50)}
                                            {item.title.length > 50 ? '..' : ''}
                                        </a>
                                    </p>
                                    <div
                                        style={{margin: 0, marginTop: '15px', fontWeight: 'normal', fontSize: ".85em"}}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <span>{item?.member?.name}</span>

                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0',
                                                minWidth: '120px',
                                                justifyContent: 'flex-end'
                                            }}>
                                                {item?.member?.id === member?.id && !shoppingComplete ? (
                                                    <>
                                                        <button
                                                            disabled={qtyLoading}
                                                            className="qtyBtn"
                                                            onClick={() => alterQty(item.id, item.platform_variant_id, item.quantity, Math.max(1, item.quantity - 1))}
                                                        >
                                                            -
                                                        </button>
                                                        <span style={{
                                                            width: '35px',
                                                            paddingTop: '3px',
                                                            textAlign: 'center',
                                                            height: '25px',
                                                            border: '1px solid #ccc',
                                                            borderLeft: '0px',
                                                            borderRight: '0px'
                                                        }}>
                                                            {item.quantity}
                                                        </span>
                                                        <button
                                                            disabled={qtyLoading}
                                                            className="qtyBtn"
                                                            onClick={() => alterQty(item.id, item.platform_variant_id, item.quantity, item.quantity + 1)}
                                                        >
                                                            +
                                                        </button>
                                                        <span style={{
                                                            width: '15px',
                                                            display: "inline-block",
                                                            marginLeft: '5px',
                                                            fill: qtyLoading ? "#ccc" : "#000",
                                                        }}>
                                                            <a className={"remove-item"} onClick={()=>{removeItem(item.id, item.platform_variant_id)}}>
                                                                <Icon source={DeleteIcon} tone={"subdued"}/>
                                                            </a>
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span style={{textAlign: 'center', minWidth: '35px'}}>{item.quantity}</span>
                                                )}
                                                <span style={{marginLeft: '15px', minWidth: '60px', textAlign: 'right'}}>
                                                    {currencyFormatter?.format(Number(item.price) ?? Number(Item.price).toFixed(2))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No items in the cart yet!</p>
                )}
            </div>
            <br/>
        </div>
    );
};

export default CartItems;
